module.exports = __webpack_public_path__ + "img/INF-A-2-II.e3350729.png";